import { createSlice } from "@reduxjs/toolkit";
import {
  getPromisesAsync,
  getPromiseByIdAsync,
  getNextPromisesAsync,
  updatePromiseAsync,
} from "./actions";

const initialState = {
  isLoading: true,
  current: null,
  all: [],
  last: null,
  count: 0,
  counts: null,
};

export const promisesSlice = createSlice({
  name: "promises",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPromisesAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPromisesAsync.fulfilled, (state, action) => {
        state.all = action.payload.promises;
        state.last = action.payload.last;
        state.count = action.payload.totalPromisesCount;
        if (action.payload.counts) {
          state.counts = action.payload.counts;
        }
        state.isLoading = false;
      })
      .addCase(getPromisesAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getNextPromisesAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getNextPromisesAsync.fulfilled, (state, action) => {
        state.all = [...state.all, ...action.payload.promises];
        state.last = action.payload.last;
        state.isLoading = false;
      })
      .addCase(getNextPromisesAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.all = [];
      })
      .addCase(getPromiseByIdAsync.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getPromiseByIdAsync.fulfilled, (state, action) => {
        state.current = action.payload;
        state.isLoading = false;
      })
      .addCase(getPromiseByIdAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.current = null;
      })
      .addCase(updatePromiseAsync.fulfilled, (state, action) => {
        state.all = state.all.map((promise) => {
          if (promise.id === action.payload.id) {
            return { ...promise, ...action.payload };
          } else {
            return promise;
          }
        });
        state.isLoading = false;
      });
  },
});

export default promisesSlice.reducer;
